import { faFileExport, faPrint } from '@fortawesome/free-solid-svg-icons';
import React, { useState, useEffect, useMemo } from 'react';
import { getCurrentCompany, getCompanyLogo, getAllFireFlowReports } from '../../../services/api';
import CircleButton from '../../../components/CircleButton';
import LabelledTextBox from '../../../components/LabelledTextBox';
import { makeCompany, makeCompanyLogo } from '../../../models';
import FireFlowReport from '../../../components/fireFlowTests/FireFlowReport';
import { makeFireFlowReport } from '../../../models';
import { addDays } from '../../../utils/dates';

const ExerciseResultsReport = () => {
  const [fireFlowReports, setFireFlowReports] = useState([]);
  const [filteredReports, setFilteredReports] = useState([]);
  const [company, setCompany] = useState(null);
  const [companyLogo, setCompanyLogo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadingCompany, setLoadingCompany] = useState(true);
  const [loadingFireFlowReport, setLoadingFireFlowReport] = useState(true);
  const [exporting, setExporting] = useState(false);
  const [filter, setFilter] = useState({
    startDate: null,
    endDate: null
  });

  useEffect(() => {
    setupCompany();
    setupFireFlowReports();
  }, []);
  useEffect(() => {
    setupCompanyLogo();
  }, [company]);
  useEffect(() => {
    filterReports();
  }, [filter, fireFlowReports]);
  useEffect(() => {
    setLoading(loadingCompany || loadingFireFlowReport);
  }, [loadingCompany, loadingFireFlowReport]);

  const setupCompany = async () => {
    try {
      setLoadingCompany(true);
      const fetchedCompany = await getCurrentCompany();
      setCompany(makeCompany(fetchedCompany));
      setLoadingCompany(false);
    } catch (ex) {
      console.log(ex);
      setLoadingCompany(false);
    }
  };

  const setupCompanyLogo = async () => {
    if (!company) return;
    const result = await getCompanyLogo(company.id);
    if (!result || result.deletedDate) return;
    setCompanyLogo(makeCompanyLogo(result));
  };

  const setupFireFlowReports = async () => {
    try {
      setLoadingFireFlowReport(true);
      const results = await getAllFireFlowReports();
      const reports = results.map(r => makeFireFlowReport(r));
      setFireFlowReports(reports);
      setLoadingFireFlowReport(false);
    } catch (ex) {
      setLoadingFireFlowReport(false);
    }
  };

  const filterReports = () => {
    const filtered = fireFlowReports.filter(r => {
      return r.testDate
        && (!filter.startDate || new Date(r.testDate) >= new Date(`${filter.startDate}T00:00`))
        && (!filter.endDate || new Date(r.testDate) < addDays(1, new Date(`${filter.endDate}T00:00`)));
    });
    console.log(filteredReports);
    setFilteredReports(filtered);
  };

  const print = () => {
    window.print();
  };

  const onChange = e => {
    const type = e.target.type;
    let value = e.target.value;
    switch (type) {
      case "number":
        value = +value;
        break;
      // case "date":
      //   value = new Date(value + ' 0:0');
      //   break;
    }
    setFilter({ ...filter, [e.target.name]: value });
  };

  const onBlur = e => {
    console.log(e.target.type);
    const type = e.target.type;
    let value = e.target.value;
    switch (type) {
      case "number":
        value = +value;
        break;
      // case "date":
      //   value = new Date(value + ' 0:0');
      //   break;
    }

    setFilter({ ...filter, [e.target.name]: value });
  };

  const reportResults = useMemo(() => filteredReports.map((r, idx) => (
    <tr className="page-break" key={idx}>
      <td>
        <FireFlowReport key={idx} fireFlowReport={r} loading={false} />
      </td>
    </tr>
  )), [filteredReports]);
  const phoneNumber = useMemo(() => company?.phoneNumber ? `(${company?.phoneNumber.substring(0, 3)}) ${company?.phoneNumber.substring(3, 6)}-${company?.phoneNumber.substring(6, company?.phoneNumber.length)}`.replace(/[\(\)\s-]+$/, '') : null, [company]);

  return (
    <div className="report valve-results-report">
      <div className="report-filter no-print">
        <LabelledTextBox type="date" label="Start Date" value={filter.startDate} name="startDate" onChange={onChange} onBlur={onBlur}/>
        <LabelledTextBox type="date" label="End Date" value={filter.endDate} name="endDate" onChange={onChange} onBlur={onBlur}/>
      </div>
      {(loading || exporting) && <div className="spinner"></div>}
      <div className="report-title">
        <h2>Exercise Results Report</h2>
        <div className="report-actions">
          {loading || <CircleButton icon={faPrint} size="large" title="Print" onClick={print} className="no-print" />}
        </div>
      </div>
      <table className="report-table">
        <thead>
          <tr>
            <td>
              <div className="report-header">
                {companyLogo ?
                  <div className="header-logo">
                    <img src={`${companyLogo?.dataType},${companyLogo?.image}`} alt={companyLogo.label} />
                  </div>
                : null}
                {company ?
                  <div className="header-details">
                    <div className="header-detail">
                      <span>{company?.name}</span>
                    </div>
                    <div className="header-detail">
                      <span>{company?.streetAddress}</span>
                    </div>
                    <div className="header-detail">
                      <span>{company?.city}{company?.city && company?.state ? ',' : null} </span>
                      <span>{company?.state} </span> 
                      <span>{company?.zipCode}</span>
                    </div>
                    {phoneNumber ?
                      <div className="header-detail">
                        <span>{phoneNumber}</span>
                      </div>
                    : null}
                  </div>
                : null}
              </div>
            </td>
          </tr>
        </thead>
        <tbody>
          {reportResults}
        </tbody>
      </table>
    </div>
  );
};

export default ExerciseResultsReport;